import { createApp } from 'vue'
import App from './App.vue'
import router from './router/'

// Bootstrap 5
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'

// ChartJS
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'

// Axios
import axios from 'axios'
import VueAxios from 'vue-axios'

createApp(App)
.use(router)
.use(Chartkick.use(Chart))
.use(VueAxios, axios)
.mount('#app')
